import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { servicesData } from './ServiceDetailPage';

const ServicesPage = () => {
  // Convert servicesData object to array
  const servicesArray = Object.values(servicesData);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-br from-mimo-primary to-mimo-accent text-white py-20">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold font-heading mb-4">
            Our Services
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Comprehensive IT, cybersecurity, and physical security solutions tailored to your business needs
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesArray.map((service) => {
              const ServiceIcon = service.icon;
              return (
                <Link
                  key={service.id}
                  to={`/services/${service.id}`}
                  className="group bg-white rounded-2xl p-8 border-2 border-slate-200 hover:border-mimo-primary hover:shadow-xl transition-all"
                >
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-mimo-primary to-mimo-accent flex items-center justify-center mb-4">
                    <ServiceIcon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-bold font-heading text-slate-900 mb-2 group-hover:text-mimo-primary transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4 line-clamp-3">
                    {service.description}
                  </p>
                  <div className="flex items-center gap-2 text-mimo-primary font-semibold group-hover:gap-3 transition-all">
                    Learn More
                    <ArrowRight className="w-5 h-5" />
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-padding bg-slate-50">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-slate-900 mb-4">
            Ready to Transform Your Technology?
          </h2>
          <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">
            Contact us today to discuss how our services can help your business thrive.
          </p>
          <Link to="/contact" className="btn-primary inline-flex items-center gap-2">
            Request Consultation
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
